export const dataLibG = [{
  word: 'gason',
  partOfSpeech: 'N',
  definition: ['son', 'boy'],
  egSentenceKw: 'Yo ni dé tifi èk dé gason.',
  egSentenceEn: 'They have two girls and two boys.',
  synonym: ['tibway'],
  antonym: [null],
  etymology: '[< Fr. garçon]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'gwi',
  partOfSpeech: 'ADJ',
  definition: ['grey'],
  egSentenceKw: 'Chouval gwi-a genyen kous-la.',
  egSentenceEn: 'The grey horse won the race.',
  synonym: ['sann', 'sann'],
  antonym: [null],
  etymology: '[< Fr. gris]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'gòch',
  partOfSpeech: null,
  definition: ['left'],
  egSentenceKw: 'Pyé gòch li kasé an aksidan-an.',
  egSentenceEn: 'His left foot was broken in an accident.',
  synonym: [null],
  antonym: ['dwèt', 'dwèt'],
  etymology: '[< Fr. gauche]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Gwanmanman ',
  partOfSpeech: 'N',
  definition: ['grandmother'],
  egSentenceKw: 'Gwanmanman mwen pa té la.',
  egSentenceEn: 'My grandmother wasn\'t there.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. grande-manman]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Gwanpapa',
  partOfSpeech: 'N',
  definition: ['grandfather'],
  egSentenceKw: 'Gwanpapa mwen sé on mason.',
  egSentenceEn: 'My grandfather is a mason.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'gwo',
  partOfSpeech: 'ADJ',
  definition: ['big', 'large'],
  egSentenceKw: 'I ka vann gwo yanm bò laplas-la.',
  egSentenceEn: 'She is selling big yams at the market.',
  synonym: ['gwan'],
  antonym: ['fin', 'titi', 'piti'],
  etymology: '[< Fr. gros]',
  dialect: '🇱🇨',
  variant: 'go',
}, {
  word: 'gwan',
  partOfSpeech: 'ADJ',
  definition: ['big', 'large'],
  egSentenceKw: 'Mété pen-an adan an gwan panyen.',
  egSentenceEn: 'Put the bread in a large basket.',
  synonym: ['gwo', 'vyé'],
  antonym: ['piti'],
  etymology: '[< Fr. gros]',
  dialect: '🇱🇨',
  variant: 'go',
}, {
  word: 'goud',
  partOfSpeech: 'N',
  definition: ['dollar'],
  egSentenceKw: 'I mandé nou dé goud pou lo mango-a.',
  egSentenceEn: 'He asked us two dollars for the heap of mangos.',
  synonym: ['dòla'],
  antonym: [null],
  etymology: '[< Fr. gourde]',
  dialect: '🇱🇨',
  variant: null,
}, {
  word: 'gòg',
  partOfSpeech: 'N',
  definition: ['liquor', 'alcoholic beverage'],
  egSentenceKw: 'Sé an kabawé sala papa mwen ka bwè gòg li.',
  egSentenceEn: 'It is in this bar my father drinks his liquor.',
  synonym: ['bwason', 'bwè'],
  antonym: [null],
  etymology: '[< Eng. grog]',
  dialect: '🇱🇨',
  variant: ['gwòg'],
}, {
  word: 'gadé',
  partOfSpeech: 'V',
  definition: ['to look', 'to look at'],
  egSentenceKw: 'Nou gadé andidan kay-la, mé nou pa wè pyèsonn.',
  egSentenceEn: 'We looked in the house, but we didn\'t see anyone.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. regarder]',
  dialect: '🇱🇨',
  variant: ['ga'],
}, {
  word: 'ga',
  partOfSpeech: 'V',
  definition: ['to look', 'to look at'],
  egSentenceKw: 'Ga yo!  Ga yo!',
  egSentenceEn: 'Look at them!  Look at them!',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. regarder]',
  dialect: '🇱🇨',
  variant: ['gadé'],
}, {
  word: 'gwiv',
  partOfSpeech: 'N',
  definition: ['tropical mockingbird', 'thrush (Minus gilvus)'],
  egSentenceKw: 'Gwiv-la fè nich li asou pyé mango-a.',
  egSentenceEn: 'The thrush made its nest in the mango tree.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. grive]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'go',
  partOfSpeech: 'N',
  definition: ['one penny', 'two cents E.C.'],
  egSentenceKw: 'Mwen achté yon chlen dé go pen.',
  egSentenceEn: 'I bought twenty-nine cents\' worth of bread.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ganyen',
  partOfSpeech: 'V',
  definition: ['to buy', 'to purchase'],
  egSentenceKw: 'Yo ganyen dé liv sik.',
  egSentenceEn: 'They bought two pounds of sugar.',
  synonym: ['achté', 'bat'],
  antonym: ['vann'],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['genyen'],
}, {
  word: 'ganyen',
  partOfSpeech: 'V',
  definition: ['to win', 'to defeat', 'to conquer'],
  egSentenceKw: 'Wa-a goumen ladjè-a la, mé i pa ganyen.',
  egSentenceEn: 'The king fought the war there, but he didn\'t win.',
  synonym: ['achté', 'bat'],
  antonym: ['vann'],
  etymology: '[< Fr. gagner]',
  dialect: '🇱🇨',
  variant: ['genyen'],
},
];
